export const doctorId = (state) => state.patient.doctorId;
export const reportId = (state) => state.report.reportId;
export const token = (state) => state.auth.token;
export const role = (state) => state.auth.role;
export const email = (state) => state.auth.userEmail;
